<template>
  <!-- A pick's chance to cover through its game (utils/liveCover.js coverPath):
       0-60 minutes across, 0-100% up, the dashed line at 50%. `spark` is the
       44x14 version for a row; the full one adds halftime and labels. -->
  <svg
    v-if="spark"
    width="44"
    height="14"
    viewBox="0 0 44 14"
    role="img"
    :aria-label="label"
    class="block"
  >
    <line x1="0" y1="7" x2="44" y2="7" stroke="rgb(255 255 255 / 0.18)" stroke-width="1" stroke-dasharray="2 3" />
    <path :d="line(44, 14, 1)" fill="none" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
  </svg>
  <div v-else>
    <svg width="100%" height="84" viewBox="0 0 300 84" preserveAspectRatio="none" role="img" :aria-label="label" class="block">
      <line x1="0" y1="42" x2="300" y2="42" stroke="rgb(255 255 255 / 0.25)" stroke-width="1" stroke-dasharray="3 4" vector-effect="non-scaling-stroke" />
      <line x1="150" y1="4" x2="150" y2="80" stroke="rgb(255 255 255 / 0.08)" stroke-width="1" vector-effect="non-scaling-stroke" />
      <path :d="area(300, 84, 5)" :fill="fill" stroke="none" />
      <path :d="line(300, 84, 5)" fill="none" :stroke="color" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke" />
    </svg>
    <div class="flex justify-between text-[9px] font-bold tracking-[0.1em] text-slate-500">
      <span>KICKOFF</span><span>HALF</span><span>FINAL</span>
    </div>
  </div>
</template>

<script>
const TONES = {
  win: { color: "#4ade80", fill: "rgb(74 222 128 / 0.10)" },
  loss: { color: "#fb7185", fill: "rgb(251 113 133 / 0.10)" },
  live: { color: "#fbbf24", fill: "rgb(251 191 36 / 0.10)" },
};

export default {
  name: "CoverChart",
  props: {
    // [{ minute, p }] from coverPath.
    path: { type: Array, required: true },
    tone: { type: String, default: "live" },
    spark: { type: Boolean, default: false },
  },
  computed: {
    color() {
      return (TONES[this.tone] || TONES.live).color;
    },
    fill() {
      return (TONES[this.tone] || TONES.live).fill;
    },
    label() {
      const values = this.path.map((point) => Math.round(point.p * 100));
      return `Chance to cover through the game, from ${values[0]}% at kickoff to ${values[values.length - 1]}%`;
    },
  },
  methods: {
    points(width, height, pad) {
      return this.path.map((point) => [
        (Math.min(60, Math.max(0, point.minute)) / 60) * width,
        height - pad - point.p * (height - 2 * pad),
      ]);
    },
    line(width, height, pad) {
      const pts = this.points(width, height, pad);
      if (!pts.length) return "";
      return "M" + pts.map(([x, y]) => `${x.toFixed(1)} ${y.toFixed(1)}`).join(" L");
    },
    area(width, height, pad) {
      const pts = this.points(width, height, pad);
      if (pts.length < 2) return "";
      const last = pts[pts.length - 1];
      return `${this.line(width, height, pad)} L${last[0].toFixed(1)} ${height - pad} L0 ${height - pad} Z`;
    },
  },
};
</script>
